import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
      id: 'partnermanagement.title',
      defaultMessage: 'Partner Management Index',
  }
});